import get from 'lodash/get';

import { CustomAttributeDefinition } from '../../CAD.types';
import { CAD_STORE_KEY } from '../../constants';
import { STATE_KEY } from './CADForm.constants';

interface CADFormStore {
	loading: boolean;
	data: CustomAttributeDefinition;
}

const getCADForm = (store: unknown): CADFormStore =>
	get(store, [CAD_STORE_KEY, STATE_KEY], {}) as CADFormStore;
export const getCADFormLoading = (store: unknown): boolean =>
	get(getCADForm(store), 'loading', false);
export const getCADFormData = (store: unknown): CustomAttributeDefinition =>
	get(getCADForm(store), 'data', {} as CustomAttributeDefinition);
